var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-bar"},[_c('IconFont',{attrs:{"name":_vm.icon}}),_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }